export default __webpack_public_path__ + "static/media/star_filled.49ed4d05.svg";